import colors from 'globals/colors'
import styled from 'styled-components'
import measures from 'globals/measures'
import { Link } from 'react-router-dom'
import { colorFromStatus } from 'components/ClientStatus/styles'

export const ClientsListWrapper = styled.div`
  height: 100%;
  display: flex;
  overflow: hidden;
`

interface ClientsListContentProps {
  noScroll: boolean
}

export const ClientsListContent = styled.div<ClientsListContentProps>`
  height: 100%;
  padding: 50px 48px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: ${(props) => props.noScroll ? 'hidden' : 'auto'};

  @media (max-width: ${measures.mobileThreshold}px) {
    padding: 16px 24px;
  }
`

interface ClientProps {
  translucent: boolean,
  status: 'activated' | 'pending_partner_check' | 'canceled'
}

export const Client = styled.div<ClientProps>`
  width: 100%;
  background: white;
  border-radius: 4px;
  margin-bottom: 8px;
  padding: 22px 24px 25px;
  opacity: ${(props) => props.translucent ? 0.2 : 1};
  border-left: 4px solid ${(props) => colorFromStatus(props.status)};
  transition: opacity 500ms;

  @media(max-width: ${measures.mobileThreshold}px) {
    padding: 11px 16px 16px;
    margin-bottom: 16px;
  }
`

export const FirstLine = styled.div`
  display: flex;
  flex-direction: row-reverse;

  @media(max-width: ${measures.mobileThreshold}px) {
    flex-direction: column;
  }
`

export const FirstLineRight = styled.div``

export const RegistrationDate = styled.div`
  height: 24px;
  line-height: 20px;
  font-size: 12px;
  color: ${colors.grey};

  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`
export const FundsSource = styled.div`
  height: 24px;
  line-height: 20px;
  font-size: 12px;
  color: ${colors.grey};
  display: flex;
  justify-content: flex-end;

  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const FirstLineLeft = styled.div`
  flex: 1;
`

export const ClientCompanyName = styled.div`
  height: 32px;
  line-height: 24px;
  font-size: 22px;
  font-weight: 800;
  i {
    font-size: 13px;
    color: ${colors.steelGrey};
  }
  @media (max-width: ${measures.mobileThreshold}px) {
    height: auto;
  }
`

export const ClientName = styled.div`
  height: 32px;
  line-height: 32px;
  font-size: 16px;
`

export const ClientAddress = styled.div`
  line-height: 22px;
  font-size: 14px;
  color: ${colors.steelGrey};
  padding-bottom: 4px;

  @media(max-width: ${measures.mobileThreshold}px) {
    padding-bottom: 6px;
  }
`

export const LastLine = styled.div`
  display: flex;
  justify-content: space-between;

  @media(max-width: ${measures.mobileThreshold}px) {
    flex-direction: column;
  }
`

export const LastLineLeft = styled.div`
  display: flex;
  flex-direction: column;
`

export const Rules = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media(max-width: ${measures.mobileThreshold}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

interface MailOptionProps {
  color?: string
}

export const MailOption = styled.div<MailOptionProps>`
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background: ${colors.lighterGrey};
  border-radius: 4px;
  margin-right: 10px;
  & > svg {
    margin-left: 6px;
  }
  @media(max-width: ${measures.mobileThreshold}px) {
    margin-top: 8px;
    margin-left: 0;
  }
  ${(props) => props.color == 'red' && `color: ${colors.reddishPink};`}
`

interface DisplayMoreProps {
  mobile?: boolean
}

export const DisplayMore = styled(Link)<DisplayMoreProps>`
  height: 24px;
  line-height: 24px;
  color: ${colors.waterBlue};
  font-size: 14px;
  font-weight: 600;
  margin-top: 15px;
  cursor: pointer;

  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }

  ${(props) => props.mobile && `
    text-align: center;
    display: none;

    @media(max-width: ${measures.mobileThreshold}px) {
      display: block;
    }
  `};

  & > span {
    text-decoration: underline;
  }

  & > img {
    margin-left: 5px;
  }
`

export const LastLineRight = styled.div`
  display: flex;
  flex-direction: column;
`

export const PendingMails = styled.div`
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-weight: 600;
  padding-left: 5px;

  & > img {
    margin-right: 10px;
  }

  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const AddMailButton = styled.div`
  width: 184px;

  @media(max-width: ${measures.mobileThreshold}px) {
    width: 100%;
    margin-top: 13px;

    & > button {
      width: 100%;
    }
  }
`

export const EmptyListWrapper = styled.p`
  alignSelf: center;
  margin: auto;
`
